import * as React from "react";
import { forwardRef } from "react";
const SvgTelegramColor = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 24, cy: 24, r: 24, fill: "#2AABEE" }), /* @__PURE__ */ React.createElement("path", { d: "m11.2 23.2 24.4-9.4c1.1-.4 2.1.3 1.7 1.9l-4.1 19.2c-.3 1.4-1.1 1.7-2.3 1.1l-6.2-4.6-3 2.9c-.3.3-.6.6-1.3.6l.4-6.4 11.7-10.6c.5-.5-.1-.7-.8-.3l-14.5 9.1-6.2-1.9c-1.4-.4-1.4-1.4.2-2Z", fill: "white" }));
const ForwardRef = forwardRef(SvgTelegramColor);
export { ForwardRef as ReactComponent };
